import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { EntShell, BtnLink, Kicker } from "@/components/enterprise/Ent";

export default function EnterpriseSuccess() {
  const [params] = useSearchParams();
  const eventId = params.get("event_id");
  const [st, setSt] = useState(null);
  useEffect(() => {
    let n = 0;
    let stop = false;
    const tick = async () => {
      try {
        const r = await api.get(`/enterprise/events/${eventId}/status`, { withCredentials: true });
        setSt(r.data);
        if (r.data.status === "pending_payment" && n++ < 10 && !stop) setTimeout(tick, 2500);
      } catch { setSt({ status: "error" }); }
    };
    tick();
    return () => { stop = true; };
  }, [eventId]);

  const paid = st?.status === "scheduled";
  return (
    <EntShell>
      <section className="max-w-xl mx-auto px-6 py-20" aria-live="polite">
        <Kicker>Team Impact™</Kicker>
        <h1 className="font-display text-4xl mt-3" data-testid="success-title">{paid ? "Your event is confirmed." : st?.status === "error" ? "We couldn't load your booking." : "Confirming your payment…"}</h1>
        {paid && (
          <>
            <p className="mt-4 text-[15px] text-[#3b3530]">We've emailed your confirmation. Share this code or link with participants when you're ready.</p>
            <div className="mt-6 bg-white border border-[#ddd5c9] rounded-lg p-6">
              <div className="text-xs text-[#5a524b]">Event code</div>
              <div className="font-display text-5xl tracking-[0.2em]" data-testid="success-code">{st.event_code}</div>
              <div className="text-sm mt-2 break-all">{window.location.origin}/e/{st.event_code}</div>
            </div>
            <BtnLink to={`/enterprise/events/${eventId}`} className="mt-6" data-testid="success-open-event">Open event and facilitator guide</BtnLink>
          </>
        )}
        {st && !paid && st.status !== "error" && <p className="mt-4 text-[15px]">This can take a few seconds. You can also check your <Link to="/enterprise/dashboard" className="underline">dashboard</Link>.</p>}
      </section>
    </EntShell>
  );
}
